(() => {
  const isAppleMobile = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  if (!isAppleMobile) return;

  document.querySelectorAll('[data-directions-address]').forEach((link) => {
    link.href = 'https://maps.apple.com/?daddr=' + encodeURIComponent(link.dataset.directionsAddress);
  });
})();
